import React from 'react';

const StatCard = ({ title, value, subtitle, icon, trend, trendValue, color = '#3b82f6' }) => {
  const cardStyle = {
    backgroundColor: 'white',
    borderRadius: '12px',
    padding: '24px',
    boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
    border: '1px solid #e5e7eb',
    transition: 'all 0.2s ease',
    cursor: 'pointer'
  };

  const headerStyle = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: '16px'
  };

  const titleStyle = {
    fontSize: '14px',
    fontWeight: '500',
    color: '#6b7280',
    margin: 0
  };

  const iconStyle = {
    fontSize: '20px',
    color: color,
    opacity: 0.8
  };

  const valueStyle = {
    fontSize: '32px',
    fontWeight: '700',
    color: '#111827',
    margin: '0 0 8px 0',
    lineHeight: '1'
  };

  const subtitleStyle = {
    fontSize: '14px',
    color: '#6b7280',
    margin: 0
  };

  const trendStyle = {
    display: 'flex',
    alignItems: 'center',
    gap: '4px',
    fontSize: '12px',
    fontWeight: '500',
    marginTop: '8px'
  };

  const trendValueStyle = {
    color: trend === 'up' ? '#059669' : trend === 'down' ? '#dc2626' : '#6b7280'
  };

  return (
    <div 
      style={cardStyle}
      onMouseEnter={(e) => {
        e.currentTarget.style.transform = 'translateY(-2px)';
        e.currentTarget.style.boxShadow = '0 4px 12px rgba(0, 0, 0, 0.15)';
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.transform = 'translateY(0)';
        e.currentTarget.style.boxShadow = '0 1px 3px rgba(0, 0, 0, 0.1)';
      }}
    >
      <div style={headerStyle}>
        <p style={titleStyle}>{title}</p>
        {icon && <span style={iconStyle}>{icon}</span>}
      </div>
      
      <div style={valueStyle}>{value}</div>
      
      {subtitle && <p style={subtitleStyle}>{subtitle}</p>}
      
      {trend && trendValue && (
        <div style={trendStyle}>
          <span style={trendValueStyle}>
            {trend === 'up' ? '↗' : trend === 'down' ? '↘' : '→'} {trendValue}
          </span>
        </div>
      )}
    </div>
  );
};

const StatCards = ({ cards = [] }) => {
  const containerStyle = {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
    gap: '24px',
  };

  return (
    <div style={containerStyle}>
      {cards.map((card, index) => (
        <StatCard
          key={index}
          title={card.title}
          value={card.value}
          subtitle={card.subtitle}
          icon={card.icon}
          color={card.color}
          trend={card.trend}
          trendValue={card.trendValue}
        />
      ))}
    </div>
  );
};

export default StatCards;
